import React, { useState } from 'react';
import { Header } from './components/Header';
import { RankStatusHero } from './components/RankStatusHero';
import { TodayScorecard } from './components/TodayScorecard';
import { MonthlyScorecard } from './components/MonthlyScorecard';
import { Roadmap } from './components/Roadmap';
import { PointsReference } from './components/PointsReference';
import { LoanFilesPanel } from './components/LoanFilesPanel';
import { LoanStage, Scope } from './data/loans';
import { FolderOpen } from 'lucide-react';
export function App() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [panelStage, setPanelStage] = useState<LoanStage | null>(null);
  const [panelScope, setPanelScope] = useState<Scope>('mtd');
  const openPanel = (stage: LoanStage | null, scope: Scope) => {
    setPanelStage(stage);
    setPanelScope(scope);
    setPanelOpen(true);
  };
  return <div className="min-h-screen bg-gray-100 flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-1 p-4 md:p-6 lg:p-8 max-w-[1600px] mx-auto w-full space-y-6" data-id="element-2">
        {/* Top Hero Section - Where I Stand */}
        <RankStatusHero data-id="element-3" />

        {/* Quick action: view all files */}
        <div className="flex justify-end" data-id="element-4">
          <button onClick={() => openPanel(null, 'mtd')} className="flex items-center gap-2 bg-white border border-gray-200 hover:border-blue-300 hover:shadow-sm text-[#0a1e5e] font-bold text-sm px-4 py-2 rounded-lg transition-all" data-id="element-5">
            <FolderOpen className="w-4 h-4" data-id="element-6" />
            View All Loan Files
          </button>
        </div>

        {/* Scorecards Section */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6" data-id="element-7">
          <TodayScorecard onTileClick={stage => openPanel(stage, 'today')} data-id="element-8" />
          <MonthlyScorecard onTileClick={stage => openPanel(stage, 'mtd')} data-id="element-9" />
        </div>

        {/* Career Roadmap */}
        <Roadmap data-id="element-10" />

        {/* Footer Reference */}
        <PointsReference data-id="element-11" />
      </main>

      {/* Drill-down Panel */}
      <LoanFilesPanel open={panelOpen} initialStage={panelStage} initialScope={panelScope} onClose={() => setPanelOpen(false)} data-id="element-12" />
    </div>;
}